import type { Brand } from './types'

export const MARCO_BRAND: Brand = {
  name: 'Marco',
  primary: '#183B67',
  primaryFg: '#FFFFFF',
  accent: '#FFC937',
  accentFg: '#2F3E54',
  surface: '#F7F5F6',
  logoUrlLight: '/brand/marco-logo.svg',
  logoUrlDark: '/brand/marco-logo.svg',
  logoAspect: '227.63 / 90.4',
  fontHeading: "'Poppins', system-ui, sans-serif",
  fontBody: "'Inter Variable', 'Inter', system-ui, sans-serif",
}
